import Flickity from "flickity";
import globalContext from "../const/globalContext";

export default function fSlider() {
    const sliders = document.querySelectorAll('.js-slider');

    function createSlider(slider) {
        const slides = slider.querySelector('.js-slider-slides');
        const nextButton = slider.querySelector('.js-next-slide');
        const prevButton = slider.querySelector('.js-prev-slide');
        const nextButtonMobile = slider.querySelector('.js-next-slide-mobile');
        const prevButtonMobile = slider.querySelector('.js-prev-slide-mobile');
        let isMobile = false;

        if(globalContext.iScreenWidth < globalContext.mobileBreakpoint){
            isMobile = true;
        }

        window.addEventListener('resize', () => {
            globalContext.iScreenWidth = window.innerWidth;

            if(globalContext.iScreenWidth < globalContext.mobileBreakpoint){
                isMobile = true;
            }
        });

        const flkty = new Flickity(slides, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            imagesLoaded: true,
            lazyLoad: 2,
            prevNextButtons: false,
            wrapAround: false,
            freeScroll: false,
            draggable: isMobile
        });

        let currentSlide = flkty.selectedIndex + 1;

        if (prevButton) {
            prevButton.classList.add("disable-prev");
        }

        if (prevButtonMobile) {
            prevButtonMobile.style.display = 'none';
        }

        function fUpdateButtons() {
            if(currentSlide === flkty.slides.length) {

                if (nextButton) {
                    nextButton.classList.add("disable-next");
                }

                if (nextButtonMobile) {
                    nextButtonMobile.style.display = 'none';
                }
            }
            else if (currentSlide === 1) {
                if (prevButton) {
                    prevButton.classList.add("disable-prev");
                }

                if (prevButtonMobile) {
                    prevButtonMobile.style.display = 'none';
                }
            }
            else if ((currentSlide > 1 || currentSlide < flkty.slides.length) && currentSlide !== flkty.slides.length) {
                if (prevButton && nextButton) {
                    prevButton.classList.remove("disable-prev");
                    nextButton.classList.remove("disable-next");
                }

                if (nextButtonMobile) {
                    nextButtonMobile.style.display = null;
                }

                if (prevButtonMobile) {
                    prevButtonMobile.style.display = null;
                }
            }
        }

        function fShowNext() {
            if(currentSlide !== flkty.slides.length) {
                flkty.next();
            } else {
                flkty.previous();
            }
        }

        function fShowPrevious() {
            if(currentSlide !== 1) {
                flkty.previous();
            } else {
                flkty.next();
            }
        }

        if (nextButtonMobile) {
            nextButtonMobile.addEventListener('click', fShowNext);
        }
        if (prevButtonMobile) {
            prevButtonMobile.addEventListener('click', fShowPrevious);
        }

        if (prevButton) {
            prevButton.addEventListener('click', fShowPrevious);
        }

        if (nextButton) {
            nextButton.addEventListener('click', fShowNext);
        }

        flkty.on( 'change', function( index ) {
            currentSlide = index + 1;

            fUpdateButtons();
        });
    }

    sliders.forEach((slider) => {
        createSlider(slider);
    });
}
